/* eslint-disable no-mixed-spaces-and-tabs */
import { h, Component } from 'preact';
import style from './style';

import Player from './../player';
import Controls from './../controls';
import { mobileCheck } from '../../helper';

export default class Theatre extends Component {
	constructor(props) {
		super(props);
		let desktopMode = 1;
		if (this.props.availableModes.length) {
			desktopMode = this.props.availableModes.includes(1) ? 1 : this.checkModeAvailability(1, 'next');
		}
		this.state = {
			mode: props.ismobile ? props.islandscape ? 2 : this.props.availableModes.includes(3) ? 3 : 2 : desktopMode
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.islandscape !== nextProps.islandscape || this.props.ismobile !== nextProps.ismobile || this.props.availableModes.length !== nextProps.availableModes.length) {
			let desktopMode = 1;
			if (nextProps.availableModes.length) {
				desktopMode = nextProps.availableModes.includes(1) ? 1 : this.checkModeAvailability(1, 'next', nextProps.availableModes);
			}
			this.setState({
				mode: nextProps.ismobile ?
					nextProps.islandscape ? 2 : nextProps.availableModes.includes(3) ? 3 : 2 : desktopMode
			});
		}
	}

  // eslint-disable-next-line react/sort-comp
  checkModeAvailability = (num, direction, modes) => {
  	const availableModes = modes || this.props.availableModes;
  	const len = 3;
  	let mode;
  	if (direction === 'back') {
  		mode = num === 1 ? len : num - 1;
  		return availableModes.includes(mode) ? mode : this.checkModeAvailability(mode, direction, availableModes);
  	}
  	else if (direction === 'next') {
  		mode = num === len ? 1 : num + 1;
  		return availableModes.includes(mode) ? mode : this.checkModeAvailability(mode, direction, availableModes);
  	}
  }

  modeSelector = (mode) => {
  	this.setState({
  		mode
  	});
  }

  render(props, state) {
  	const availableModes = props.availableModes;
  	const onlyInterstitial =
	    availableModes.length === 1 && availableModes.includes(2);
  	const isMobile = mobileCheck();
  	const hideControls = isMobile && onlyInterstitial;
  	return (
  		<div class={`previewlink-app ${props.parentclass}`}>
  			<Player
  				hideControls={hideControls}
  				modeSelector={this.modeSelector}
  				mode={state.mode}
  				playerReady={this.props.playerReady}
  				availableModes={this.props.availableModes}
  				checkModeAvailability={this.checkModeAvailability}
          		aspectRatio={this.props.aspectRatio}
  			/>
  			{!hideControls && <Controls modeSelector={this.modeSelector} mode={state.mode} availableModes={this.props.availableModes} />}
  		</div>
  	);
  }
}



// WEBPACK FOOTER //
// ./components/theatre/index.js